import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { getConfig, getConfigKey } from '@utils/config-utils';

import Logo from '@icons/header/logo';

import UnstyledHeading from '@components/shared/unstyled-heading';
import ActionItems from './action-items';
import Links from './links';

import './header.scss';

const Header = ({headerId}) => {
  const somConfig = getConfigKey('somDigitalStandards');

  return (
    <div styleName="header-container">
      <div styleName="header-inner-container">
        <UnstyledHeading rank={1} id={headerId} styleName="header-title">
          <span styleName="logo"><Logo/></span>
          <span styleName="label">
            {somConfig?.enabled
              ? `${somConfig.headerTitle || ''} | ${somConfig.appName || getConfig().cityName}`
              : getConfig().cityName
            }
          </span>
        </UnstyledHeading>
        <Links />
      </div>
      <ActionItems />
    </div>
  );
};

Header.propTypes = {
  headerId: PropTypes.string
};

export default memo(Header);
